// Exports
export default {
	"empty": "empty_w71Ky",
	"sidebar": "sidebar_j9rsh",
	"title": "title_KCVU8",
	"artifacts": "artifacts_UMHzA",
	"oneColLayout": "oneColLayout_mLGtI",
	"artifactsGroup": "artifactsGroup_ypIo4",
	"meetingReport": "meetingReport_HCLXE",
	"tooltip": "tooltip_MVICH"
};
